import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BuilderState {
  private saveAll$: Subject<void> = new Subject();

  public saveAll(): void {
    this.saveAll$.next();
  }

  public observe(): Observable<void> {
    return this.saveAll$.asObservable();
  }
}
